import { Text } from '@jfs/ui-new/'
import { formatTimer } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'

interface timerInterface {
  timer: number
  showTimer: boolean
}

export const TimerComp = ({ timer, showTimer }: timerInterface) => {
  if (!showTimer) {
    return null
  }

  return (
    <ModBox show={timer > 0} pr={16}>
      <Text type={'h4'} color={'TEXT_ERROR'}>
        {formatTimer(timer)}
      </Text>
    </ModBox>
  )
}
